import { render, staticRenderFns } from "./BlockDetail.vue?vue&type=template&id=383e98b2&"
import script from "./BlockDetail.vue?vue&type=script&lang=js&"
export * from "./BlockDetail.vue?vue&type=script&lang=js&"
import style0 from "./BlockDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports